<template>
<div>
  <v-card flat class="card item card-outer" height=200 hover>
    <div>
      <v-layout row>
        <v-flex xs3>
          <v-layout column align-center>
            <v-layout row>
          <v-icon :color="color" :style="{paddingTop: (height / 6) + 'px'}" :size="height / 3">
          {{icon}}
          </v-icon>
          </v-layout>
          <v-layout row>
          <button class="addbutton" @click="viewDoc(item)">View</button>
          </v-layout>
          </v-layout>
        </v-flex>
        <v-spacer />
        <v-flex xs1>
        </v-flex>
        <v-flex xs8>
          <p :style="{fontWeight: 'bold', paddingTop: '15px', paddingLeft: '0px', fontSize: '1.3rem', color: dark ? 'orange' : 'red'}">{{item.group }}</p>
          <p style="margin-top: 3px; padding-left: 3px; font-weight: 600;"> {{item.heading}} </p>
          <p :style="{marginTop: '1px', paddingLeft: '3px', color: dark ? 'lightGrey' : '#444444'}"> {{item.desc}} </p>
        </v-flex>
 
      </v-layout>
    </div>
    <v-card-actions class="card-actions">
      <!-- <button class="addbutton" @click="viewDoc(item)">View Document</button> -->
    </v-card-actions>
  </v-card>
  </div>
</template>
<script>
import axiosInstances from "@/../../coreui/server/axiosInstances"
import { sync } from "vuex-pathify"
export default {
  name: 'Policy_DisplayItem',
  props: ['item', 'height', 'extra'],
  data () {
    return {
    }
  },
  computed: {
    user: sync('login/loggedinUser'),
    dark: sync('misc/dark'),
    color () {
      if (this.item.color == null || this.item.color.length < 6) {
        return('#00ff00')
      }
      return '#'+this.item.color.substring(2)
    },
    icon () {
      let i
      if (this.item.icon == null || this.item.icon == '') i = 'mdi-document'
      else i = 'mdi-' + this.item.icon.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
      return i
    }
  },
  methods: {
    async viewDoc(item) {
      let res = await axiosInstances.apiServer.get(item.link)
      if (res != null && res.data != null) {
        this.$router.push({ name: 'DisplayHTML', params: {
          title: item.group + ' - ' + item.heading,
          html: res.data
        }})
      } else {
        this.$router.push({ name: 'DisplayHTML', params: {
          title: 'Error',
          doc: '<h1>Document not found</h1>'
          }})
      }
    },
  },
  mounted () {
    this.elog('trace', "Item is: {}", this.item)()
  }
}
</script>
<style scoped>
.v-tooltip__content.menuable__content__active {
  opacity: 1 !important;
}
.addbutton {
  margin-left: 0px;
  margin-top: 10px;
  padding: 5px;
  border: 1px;
  background: green;
  transition: all 0.1s ease-out;
  border-radius: 5px;
  color: white;
}
.card-actions {
  position: absolute;
  bottom: 0;
}
</style>